module.exports = __webpack_public_path__ + "static/img/wechat.d110b16.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/channel/wechat.png
// module id = QI5L
// module chunks = 1